/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { isBlank } from '@ember/utils';
import AssetLibraryBaseItemComponent from 'cio/components/asset-library/base-item';

export default class AssetLibraryGridItem extends AssetLibraryBaseItemComponent {
  get createdByName() {
    let { createdBy } = this.args.asset;

    let displayName = '';
    if (createdBy == null) {
      return displayName;
    }

    if (!isBlank(createdBy.firstName)) {
      displayName = `by ${createdBy.firstName}`;
      if (!isBlank(createdBy.lastName)) {
        displayName += ` ${createdBy.lastName}`;
      }
    } else if (!isBlank(createdBy.email)) {
      displayName = `by ${createdBy.email}`;
    }

    return displayName;
  }

  get imageContainerClasses() {
    if (this.args.asset.isDir) {
      return 'py-2';
    }

    return `rounded border-1 ${this.args.asset.isPdf ? 'bg-gray-100' : 'bg-checkered'}`;
  }
}
